import { render, staticRenderFns } from "./TvDetails.vue?vue&type=template&id=bbe24996&scoped=true&"
import script from "./TvDetails.vue?vue&type=script&lang=js&"
export * from "./TvDetails.vue?vue&type=script&lang=js&"
import style0 from "./TvDetails.vue?vue&type=style&index=0&id=bbe24996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe24996",
  null
  
)

export default component.exports